// extracted by mini-css-extract-plugin
export var Body = "styles-module--Body--ukcYA";
export var Footer = "styles-module--Footer--02JID";
export var Link = "styles-module--Link--Xy3eY";
export var Message = "styles-module--Message--2IIr-";
export var Wrapper = "styles-module--Wrapper--j-tep";